<template>
    <div v-if="nodeManifest.children" class="artifact">
        <template v-for="node in nodeManifest.children">
            <template v-if="isContainerComponent(node)">
                <component
                    :is="node.element"
                    :key="getFieldId(node)"
                    :nodeManifest="node"
                >
                    <x-dynamic :nodeManifest="node" />
                </component>
            </template>
            <template v-else-if="hasComponent(node.element)">
                <component
                    :is="node.element"
                    :key="getFieldId(node)"
                    :nodeManifest="node"
                    :data-errors = "getErrorsFromNode(node)"
                >
                </component>
            </template>
            <template v-else>
                <x-element
                    :key="getFieldId(node)"
                    :element="node.element"
                    :text="node.attributes.text"
                    >
                </x-element>
            </template>
        </template>
    </div>
</template>

<script>
import { mapGetters, } from 'vuex';
import framework from '../../framework';
/**
 *  The x-dynamic component.
 *  @module components/x-dynamic
 */

/**
 * The x-dynamic component drives the recursive component generation.
 */

export default {
    name: 'x-dynamic',
    mixins: [
        framework.mixins.abstractInput,
    ],
    computed: {
        ...mapGetters({
            submitFormHasBeenAttempted: 'submitFormHasBeenAttempted',
        }),
    },
    methods: {
        /**
         * Gets errors from a node.
         * @param {*} node the node.
         * @returns {*} the errors array.
         */
        getErrorsFromNode(node) {
            if (node.children && node.children.length > 0 && node.children[0].errors) {
                return node.children;
            }
            return null;
        },

        /**
         * Gets whether children are error nodes.
         * @param {*} node the node.
         * @returns {boolean} whether any children are not error nodes.
         */
        /*eslint-disable*/
        hasNonErrorChildren(node) {
            return true;
        },

        /**
         * Checks the application registry to see if component has been registered.
         * @param {string} componentName the componentName
         * @returns {boolean} true if the component has been registered.
         */
        hasComponent(componentName) {
            return this.applicationInstance.componentList.find((c) => c === componentName);
        },


        /**
         * Checks whether the component is a container component.
         * @param {*} node the node.
         * @returns {boolean} true if the component is a container component.
         */
        isContainerComponent(node) {
            if (node.children
                && node.children.length > 0
                && !this.isComplexComponent(node)
                && this.hasNonErrorChildren(node)) {
                return true;
            }
            return false;
        },
        /**
         * Checks the error child to see if this is a complex component with errors.
         * @param {*} node the node.
         * @returns {boolean} true if the component is a complex component.
         */
        isComplexComponent(node) {
            let isComplexComponent = false;
            if (!(node.children
                && node.children[0].errors
                && Array.isArray(node.children[0].errors))) {
                return false;
            }

            node.children[0].errors.forEach((e) => {
                if (e.id !== node.attributes.id) {
                    isComplexComponent = true;
                }
            });

            return isComplexComponent;
        },
    },
};
</script>



// WEBPACK FOOTER //
// source/components/x-dynamic/x-dynamic.vue